export enum MIMETypesEnum {
  jpg   = 'image/jpeg',
  jpeg  = 'image/jpeg',
  png   = 'image/png',  //si no viene extension por defecto
  doc   = 'application/msword',
  docx  = 'application/msword',
  pdf   = 'application/pdf',
  mp4   = 'video/quicktime',
  xls   = 'application/vnd.ms-excel',
  xlsx  = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
}